import { isValidString } from '@nykaa/utils/validations';
import { CROP_STRATEGY, DEFAULT_HEIGHT, DEFAULT_WIDTH, GIF, MAX_WIDTH, PAD_RESIZE, } from '../constants';
export const getAbsoluteSize = (cWidth, cHeight, isAbsoluteSize) => {
    if (isAbsoluteSize) {
        return {
            width: cWidth,
            height: cHeight,
        };
    }
    if (!cWidth) {
        return {
            width: null,
            height: cHeight,
        };
    }
    let size;
    switch (true) {
        case (cWidth <= 50):
            size = 50;
            break;
        case (cWidth <= 150):
            size = 150;
            break;
        case (cWidth <= 200):
            size = 200;
            break;
        case (cWidth <= 300):
            size = 300;
            break;
        case (cWidth <= 500):
            size = 500;
            break;
        case (cWidth <= 600):
            size = 600;
            break;
        default:
            size = cWidth <= MAX_WIDTH ? cWidth : MAX_WIDTH;
    }
    return {
        width: size,
        height: cHeight && size,
    };
};
export const getCroppingStrategy = (cropStrategy) => {
    switch (cropStrategy) {
        case CROP_STRATEGY.padResize:
            return PAD_RESIZE;
        default:
            return '';
    }
};
export const getImgQueryString = ({ cropStrategy, width, height, trim, scale = 1, }) => {
    let query = '?tr=';
    let separator = '';
    if (cropStrategy) {
        query += getCroppingStrategy(cropStrategy);
        separator = ',';
    }
    if (width) {
        query += `${separator}w-${width * scale}`;
        separator = ',';
    }
    if (height) {
        query += `${separator}h-${height * scale}`;
        separator = ',';
    }
    // fallback height and width if not avaiable (500*500)
    if (!width && !height) {
        query += `${separator}w-${DEFAULT_WIDTH * scale},h-${DEFAULT_HEIGHT * scale}`;
        separator = ',';
    }
    if (trim) {
        query += `${separator}t-${trim}`;
    }
    return query;
};
export const isSrcSetRequired = (url) => {
    var _a;
    if (!isValidString(url)) {
        return false;
    }
    const splittedUrl = url.split('.');
    const format = (_a = splittedUrl[splittedUrl.length - 1]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return !(format === GIF);
};
export const oldScaleImage = ({ url, width, height, cropStrategy, }) => {
    let qs = '';
    let newUrl = `${url}`;
    if (width || height) {
        if (url.indexOf('?') === -1) {
            qs = '?';
        }
        qs += 'tr=';
        if (width) {
            qs += `w-${width},`;
        }
        if (height) {
            qs += `h-${height},`;
        }
        if (cropStrategy === CROP_STRATEGY.padResize) {
            qs += 'cm-pad_resize';
        }
    }
    newUrl += qs;
    return newUrl;
};
